import { availablePermissions } from '@portal/actions/user';
import AdvancedHeader from '@portal/components/AdvancedHeader/AdvancedHeader';
import AdvancedPanelContentHeader from '@portal/components/AdvancedPanelContentHeader/AdvancedPanelContentHeader';

import { getRouteStackPath } from '@portal/config/routes';
import useReduxState from '@portal/hooks/useReduxState';

import { translate } from '@portal/services/i18n';
import { Col } from 'antd';

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const MyPermissionsMultiAccess = () => {
  const dispatch = useDispatch();
  const [permissionNames, setPermissionNames] = useState<string[]>([]);

  const {
    user: { permissionsList, roles },
  } = useReduxState();

  useEffect(() => {
    dispatch(availablePermissions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getPermissionNames = (
      permissionsList: models.PermissionsList[],
      roles: string[]
    ) => {
      const names: string[] = [];

      for (const access of roles) {
        const permission: models.PermissionsList | undefined =
          permissionsList.find((permission) => permission.value === access);
        if (permission && permission.name !== null) {
          names.push(permission.name);
        }
      }

      return names;
    };

    const names = getPermissionNames(permissionsList, roles);
    const namesFiltered = names.filter((item) => item !== null);
    setPermissionNames(namesFiltered);
  }, [permissionsList, roles]);

  return (
    <>
      <AdvancedHeader
        showBreadCrumbs
        breadCrumbs={[
          {
            active: true,
            title: translate('PAGES.HOME.PAY.BREADCRUMB.HOME'),
            url: getRouteStackPath('HOME', 'HOME_PAGE'),
          },
          {
            active: true,
            title: translate('PAGES.MY_ACCOUNT.TABS.ACCOUNT'),
            url: getRouteStackPath('PROFILE', 'PROFILE_PAGE'),
          },
          {
            active: true,
            title: translate('PAGES.MY_ACCOUNT.MULTI_ACCESS.TITLE'),
            url: getRouteStackPath('PROFILE', 'MULTI_ACCESS'),
          },
          {
            active: false,
            title: translate(
              'PAGES.MY_ACCOUNT.MULTI_ACCESS.TABS.MY_PERMISSIONS.TITLE'
            ),
          },
        ]}
      />
      <div className="multiaccess-page">
        <AdvancedPanelContentHeader
          title={translate(
            'PAGES.MY_ACCOUNT.MULTI_ACCESS.TABS.MY_PERMISSIONS.TITLE'
          )}
          description={translate(
            'PAGES.MY_ACCOUNT.MULTI_ACCESS.TABS.MY_PERMISSIONS.DESCRIPTION'
          )}
          testId="multiaccess-my-permissions-header"
        />
      </div>
      <Col className="multiaccess-page__my-permissions">
        <ul>
          {permissionNames.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Col>
    </>
  );
};

export default MyPermissionsMultiAccess;
